export function debounce(callback, delay) {
    let timeout;

    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => callback.apply(context, args), delay);
    };
}

export function remove(items, predicate) {
    const removed = [];

    for (let index = items.length - 1; index >= 0; index -= 1) {
        if (predicate(items[index], index, items)) {
            removed.unshift(...items.splice(index, 1));
        }
    }

    return removed;
}

export function take(items, count = 1) {
    return items.slice(0, count);
}

export function join(items, separator = ",") {
    return items.join(separator);
}
